module.exports = __webpack_public_path__ + "static/media/s8.4b50dc7b.png";